export const appConfig = {
  production: true,
  apiHost: 'https://test.magic-cut.in',
  env: 'STAGING',
};
